import API from "@unisearch/helpers/api";
import { Fragment } from "react";

import { ClientReview } from "@modules/study/common";
import { StudyOverviewTopRankTwo } from "@modules/study/country/study_overview";
import { UniProfileWrapper } from "@modules/study/university";
import UniReviewBox from "@modules/study/university/components/uni_thumb_grid_box/uni_review_box/uni_review_box";
import {
  UniOverview,
  UniOverviewAdmission,
  UniOverviewCampus,
  UniOverviewCourses,
  UniOverviewScholarship,
} from "@modules/study/university/uni_overview";
import { excerpt } from "@unisearch/helpers";
import { LayoutMain } from "@unisearch/theme/layout";

const UniversityOverview = ({
  universityProfileData,
  courseLevelData,
  country_name,
  university_name,
  overviewText,
}) => {
  const levelCount = courseLevelData?.filter(
    (item) => item.totalCourse != 0 && item.totalCourse != null
  );

  return (
    <LayoutMain
      footer_with_evaluation
      title={
        universityProfileData
          ? `${universityProfileData?.universityName} - Ranking, Fees, Scholarships Courses, Admissions`
          : ""
      }
      metaDescription={
        overviewText
          ? excerpt(overviewText, 500)
          : `${universityProfileData?.universityName} - Ranking, Fees, Scholarships Courses, Admissions`
      }
      metaImage={
        universityProfileData?.featureSrc ||
        universityProfileData?.coverphotoLogoSrc
      }
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/study/${country_name}/university/${university_name}`}
    >
      <Fragment>
        <UniProfileWrapper uniProfileData={universityProfileData}>
          <UniOverview universityProfileData={universityProfileData} />
          <UniOverviewAdmission universityProfileData={universityProfileData} />
          <UniOverviewScholarship
            universityProfileData={universityProfileData}
          />
          <UniOverviewCourses universityProfileData={universityProfileData} />
          <UniOverviewCampus universityProfileData={universityProfileData} />
          <ClientReview universityProfileData={universityProfileData} />
          <UniReviewBox uniProfileData={universityProfileData} />
          <StudyOverviewTopRankTwo
            backgroundColor="transparent"
            padding="0"
            heading={`Popular Universities of ${universityProfileData?.CountryName}`}
            subHeading="Take a closer look at the universities, colleges, and institutes popular among international students across major study abroad destinations."
          />
        </UniProfileWrapper>
      </Fragment>
    </LayoutMain>
  );
};

export default UniversityOverview;

export async function getServerSideProps({ params }) {
  const { country_name, university_name } = params;

  let props = {
    universityProfileData: {},
    country_name,
    university_name,
    overviewText: "",
  };

  try {
    const res = await API.get(`/public/university/${university_name}`);
    if (!res.error && res.data) {
      props.universityProfileData = res.data;
    } else {
      return {
        notFound: true,
      };
    }
    const overviewTextRes = await API.get(
      `/public/university/get-overview/${university_name}`
    );
    if (!overviewTextRes.error && overviewTextRes.data) {
      props.overviewText = overviewTextRes.data.universityOverview;
    }

    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
